

'use client'

import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import {useRouter} from 'next/navigation';

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  OutlinedInput,
  Stack,
  Typography
} from "@mui/material";

// third party
import * as Yup from "yup";
import { Formik } from "formik";

// project imports
import AnimateButton from "@/app/ui-component/extended/AnimateButton";

// assets
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useIntl } from "react-intl";


import { getUserAdminConnectd, getUserEmail, getUserEmailEtudiants, getUserEmailProfessors, getUserEtudiantConnectd, getUserProfesseurConnectd, userAdminDisconect } from "@/app/services/admin/UserLogin.services";
import { DASHBOARD_PATH } from "@/app/config";
import { DASHBOARD_FUNCIONARIOS } from "@/app/config";
import { ALTERAR_SENHA_PATH, ALTERAR_SENHA_PATHSTUDENTS } from "@/app/config";

import { notificacaoCountNaoLida,  setNotificationValue  } from "@/app/store/slices/notificacaoUsuarios2";
import { dispatch } from "@/app/store";
import { logUtilisateurs } from "@/app/global-functions/UserEnLigneLogOut";
import { Home } from "@mui/icons-material";
import useAuth from "@/app/hooks/useAuth";
import swal from "sweetalert";
import { useOnlineStatus } from "@/app/hooks/OnlineStatusContext";
import { useSelector } from "@/app/store";
import {dashboardAdminResumeDepartementTurnoIDTotal, dashboardAdminResumePagamento7DiaGet, dashboardAdminResumePagamentoDoDia, dashboardAdminResumeTurnoID, getAcademicYear, getAcademicYearProfApi, getAllAnneeAcademique, getAllAnneeAcademiqueStudents, getAllStudentCoursAccessEstudantStudentApi, getAllStudentCoursAccessEstudante, getAllStudentDeUniversity, getAllUniteenseignementByUniveristy, getAllUser, getAllUserAdministracao, getAllUserFavorite, getAllUserFavoriteStudebts, getAllUserProfesssor, getCalendarioAvaliation, getCalendarioAvaliationProfApi, getCoursDuration, getCoursDurationProfApi, getCoursDurationStudentApi, getCoursProf, getCoursProfProfApi, getCurrencyAll, getFaculty, getFacultyForConfigOnly, getFacultyProfApi, getPAymentCaisseStudent, getPAymentCaisseStudentStudentApi, getPaymentsmouvements, getPaymentsmouvementsStudentApi, getSaldoEstudent, getSaldoEstudentStudentApi, getTurma, getTurmaProfApi, getTurno, getTurnoProfApi, getUniversity, getUniversityProfApi, getUniversityStudentApi, getYearStudentCoursDistinct, getYearStudentCoursDistinctStudentApi, getresetState, gteDepartement, gteDepartementProfApi, setParamMemoire} 
from "@/app/store/slices/diversParametersRedux";
import { getUniversityName } from "@/app/global-functions/getUniversityName";
import { escapeHTMLFunctionLoadHash } from "@/app/global-functions/escapeHTMLFunctionLoadHash";
// import socketIOClient from 'socket.io-client';

import Swal from "sweetalert2";
import { handleRedirection } from "@/app/global-functions/handleRedirection";
import useConfig from "@/app/hooks/useConfig";

import "leaflet/dist/leaflet.css"; // Import CSS for Leaflet
import UserService from "@/app/services/admin/User.service";
import { getBaseURL } from "@/app/global-functions/baseURLUtils-administrators";
import { getBaseURL as getBaseURLStudents }  from "@/app/global-functions/baseURLUtils-studens";

// import Cookies from "js-cookie";


const FirebaseLogin = ({ loginProp, ...others }) => {
  const theme = useTheme();
  const [message, setMessage] = useState("");
  const [errorDisplay, setErrorDisplay] = useState(false);

  const intl = useIntl();
  const navigate = useRouter();
  const { borderRadius, locale, onChangeLocale } = useConfig();

  let testData = [];
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const isOnline = useOnlineStatus();

  const [administrativo, setAdministrativo] = useState(true);
  const [professor, setProfessor] = useState(false);
  const [estudante, setEstudante] = useState(false);

  const [showPassword, setShowPassword] = React.useState(true);

  const [language, setLanguage] = useState(locale);

  const [loading, setLoading] = useState(false); // Add loading state

  const fallbackImage = "/images/default-user.png"; // Default fallback image

const [currentLoading, setCurrentLoading] = useState(''); // Track current action
const [loadingNotification, setLoadingNotification] = useState(false);

const [connectionToFuturiss, setconnectionToFuturiss] = useState(false);

let timerInterval;
 let timerCal = 23000;

const [loadingDispatch, setLoadingDispatch] = useState({
  getUniversity: false,
  getTurno: false,
  getCoursDuration: false,
  getAllUserProfesssor: false,
  getAllUserAdministracao: false,
  getAllUserFavorite: false
});
  // const socket = io(url); 

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [abreviaturaUniversidade, setabreviaturaUniversidade] = useState("");
  const [universidae, setUniversidae] = useState("");
  const [userId, setuserId] = useState("");

  useEffect(() => {   

  //  resetAllReduxstates(); // reset all redux  resetState

    fetchUniversityName();
  }, [abreviaturaUniversidade]);


  const handleChangeAdministrativo = async(event) => {
    if(event.target.checked) {
      setAdministrativo(true);
      setProfessor(false);
      setEstudante(false);
    }
  };

  const handleChangeProfessor = async(event) => {
    if(event.target.checked) {
      setAdministrativo(false);
      setProfessor(true);
      setEstudante(false);
    }
  };

  const handleChangeEtudiant = async(event) => {
    if(event.target.checked) {
      setAdministrativo(false);
      setProfessor(false);
      setEstudante(true);

    }
  };

  const fetchUniversityName = async () => {

    const university = await getUniversityName();

    setabreviaturaUniversidade(university.abreviatura);
    setUniversidae(university.nomUniversite);

  };

  const handleClick = () => {
    handleRedirection(abreviaturaUniversidade, navigate);
  };

  const getDadosEntradaParaIndexDB = async (universityID, userID, role) => {
    
    /* setImmediate(() => {
      (async () => {
        try {
          await Promise.all([
            dispatch(getUniversity("GetUnniversityForCombobox", userID, role)),      
            dispatch(getTurno("General-san-filter")),   
            dispatch(getAllUserProfesssor("userGetAllByUniversityProf")),
            dispatch(getAllUserAdministracao("userGetAllForAdmini", universityID)),
            dispatch(getAllUserFavorite("userGetAllForAdmini", userID)),
          ]);
        } catch (error) {
          console.error("Error in Promise.all:", error);
        }
      })();
    }); */

  };

  /* 
  const getDadosEntradaParaIndexDB = async () => {


    return Promise.all([
      
        dispatch(getUniversity("GetUnniversityForCombobox")),      
       dispatch(getTurno("General-san-filter")),   


      dispatch(getCoursDuration("All_coursDuration", "")),
       dispatch(getAllUserProfesssor("userGetAllByUniversityProf")),
      dispatch(getAllUserAdministracao("userGetAllForAdmini")),
       dispatch(getAllUserFavorite("userGetAllForAdmini")),
 
      
    ])
  } */

  const resetAllReduxstates = async () => {
    return Promise.all([
      dispatch(getresetState())
    ])
  }

  const disconnectUser = async (userID, ip) => {
    // Log the attempt to disconnect
    Swal.fire({
      icon: "info",
      title: intl.formatMessage({ id: "disconnecting_user" }),
      html: `<b>${intl.formatMessage({ id: "please_wait" })}</b>`
      +'<br>' + intl.formatMessage({ id: "disconnect_avoid_message" }) ,
      allowOutsideClick: false,
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    const disconnect = {
      disconectBeforeConnect: 1,
      tipo: "suserdisconncting",
      userID,
      enligne: 0,
    };
  
    await UserService.update(userID, disconnect)
      .then(async(response) => {

     //   await UserService.update(userID, disconnect);
        // Start the timer after the instruction is sent successfully
        setTimeout(() => {
          Swal.fire({
            icon: "success",
            title: intl.formatMessage({ id: "informacao_dados_gravados" }),
            text: intl.formatMessage({ id: "disconect_sent_" }),
          });
        }, 25000); // 10-second delay
      })
      .catch((error) => {
        // Handle error immediately
        Swal.fire({
          icon: "error",
          title: intl.formatMessage({ id: "disconnect_error" }),
          text: intl.formatMessage({ id: "user_disconnected_error" }),
        });
      });
  };
  
  const disconnectUserStudent = async (userID, ip) => {
    // Log the attempt to disconnect
    Swal.fire({
      icon: "info",
      title: intl.formatMessage({ id: "disconnecting_user" }),
      html: `<b>${intl.formatMessage({ id: "please_wait" })}</b>`
      +'<br>' + intl.formatMessage({ id: "disconnect_avoid_message" }) ,
      allowOutsideClick: false,
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    const disconnect = {
      disconectBeforeConnect: 1,
      tipo: "suserdisconncting",
      userID,
      enligne: 0,
    };
  
    await UserService.updateStudent(userID, disconnect)
      .then(async(response) => {
      
      await  UserService.updateStudent(userID, disconnect)


       await  UserService.updateStudent
        // Start the timer after the instruction is sent successfully
        setTimeout(() => {
          Swal.fire({
            icon: "success",
            title: intl.formatMessage({ id: "informacao_dados_gravados" }),
            text: intl.formatMessage({ id: "disconect_sent_" }),
          });
        }, 15000); // 10-second delay
      })
      .catch((error) => {
        // Handle error immediately
        Swal.fire({
          icon: "error",
          title: intl.formatMessage({ id: "disconnect_error" }),
          text: intl.formatMessage({ id: "user_disconnected_error" }),
        });
      });
  };

  async function storeImageAsBase64(imageUrl) {
    try {
      const base64Image = await getImageAsBase64(imageUrl);
      localStorage.setItem('storedIUsermage', base64Image);
    //    console.log('Image555555555555########## saved in localStorage');
    } catch (error) {
      localStorage.setItem('storedIUsermage', "");

    //  console.error('Error storing image:', error);
    }
  }

  async function getImageAsBase64(imageUrl) {
    const response = await fetch(imageUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch image at ${imageUrl}`);
    }

    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
    });
  }


const timercontroleTimeAccess = () => {
  const startTime = Date.now();
  let timerInterval;

  Swal.fire({
    title: intl.formatMessage({ id: "alerte_automatique" }),
    html: `${intl.formatMessage({ id: "futuriss_timer_ouverture" })} <b></b>`,
    timer: timerCal,
    timerProgressBar: true,
    didOpen: () => {
      Swal.showLoading();
      const b = Swal.getHtmlContainer().querySelector("b");
      if (b) {
        timerInterval = setInterval(() => {
          const elapsedTime = Date.now() - startTime;
          b.textContent = (elapsedTime / 1000).toFixed(2);
        }, 100);
      }
    },
    willClose: () => {
      clearInterval(timerInterval);
    },
  });
};

 const stopTimer = () => {
  clearInterval(timerInterval); // Function to stop the timer manually
  Swal.close();                 // Close the Swal popup
};


  return (
    <>
      <Formik
        initialValues={{
          email: "", // 'info@sigra.com',
          password: "", // '123456',
          submit: null,
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email("Email invalide")
            .max(255)
            .required(
              intl.formatMessage({ id: "login_o_email_e_obrigatorio" })
            ),
          password: Yup.string()
            .max(255)
            .required(
              intl.formatMessage({ id: "login_a_senha_e_obrigatoria" })
            ),
        })}
       
       onSubmit={async (values) => {
          try {

            setconnectionToFuturiss(true);
            timercontroleTimeAccess();

            
            if (!administrativo && !professor && !estudante) {
              Swal.close();
              setTimeout(() => {
                Swal.fire({
                  title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                  html: `<b>${intl.formatMessage({ id: "login_usuario_error" })}</b><br>${intl.formatMessage({ id: "consulter_administrateur" })}`,
                  icon: "error"
                });
              }, 100);  // Small delay to ensure Swal closes first

              setIsButtonDisabled(false);
              stopTimer();

              return;
            }
        
            if (!isOnline) {

              Swal.close();
              setTimeout(() => {
                Swal.fire({
                  title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                  html: `<b>${intl.formatMessage({ id: "internet_connexion_perdu_message" })}</b><br>${intl.formatMessage({ id: "consulter_administrateur" })}`,
                  icon: "error"
                });
              }, 100);  // Small delay to ensure Swal closes first

              setIsButtonDisabled(false);
              stopTimer();
              return;
            }
                
            let responseCheckAdmin;
            let responseStudent;
            let responseProf;


            let response;
        
            if (administrativo) {

              response = await getUserEmail(values.email, values.password, 1);
            
              if (response.data.error === "Invalid password" && response.data.attemptCount === undefined) {
            
                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                    html: `<b>${intl.formatMessage({ id: "usuario_senha_incorrecrta" })}</b><br>${intl.formatMessage({ id: "consulter_administrateur" })}`,
                    icon: "error"
                  });
                }, 100);  // Small delay to ensure Swal closes first
  
                setIsButtonDisabled(false);
                stopTimer();
            
                return;
              }


              if (Number(response.data.attemptCount) < 4) {

                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "attention_" }),
                    html: intl.formatMessage({ id: "nombre_tentativas_aviso" }) + (4 - Number(response.data.attemptCount)) + intl.formatMessage({ id: "tentativas" }) + "</br>"
                      + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                    icon: "warning"
                  });
                }, 100);  // Small delay to ensure Swal closes first
  
                setIsButtonDisabled(false);
                stopTimer();

                return;
              }
          
              if (Number(response.data.attemptCount) >= 4) {

                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "attention_" }),
                    html: '<b>' + intl.formatMessage({ id: "contabloqueado_tentitavas" }) + '</b>' + "</br>"
                    + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                    icon: "warning"
                  });
                }, 100);  // Small delay to ensure Swal closes first
  
                setIsButtonDisabled(false);
                stopTimer();

                return;
              }
          
             

            //  responseCheckAdmin = await getUserAdminConnectd(values.email);



            //   return
            

            /*   if (Number(responseCheckAdmin && responseCheckAdmin.countData) > 0) {

                const dateTransformed =  await formatDateDayMonYearAndEnglish(responseCheckAdmin.dataconnection, responseCheckAdmin.language);
   
                const ip = responseCheckAdmin.ip;
              
                const location = await getLocationByIP(ip);
              
                // Prepare location details
                const locationDetails = location
                  ? `
                      <b>${intl.formatMessage({ id: "userDejaConnecte_location" })}</b> ${location.city}, ${location.country}<br>
                      <div id="map" style="width: 100%; height: 300px; margin-top: 10px;"></div>
                    `
                  : intl.formatMessage({ id: "location_unavailable" });
              
                Swal.fire({
                  title: intl.formatMessage({ id: "attention_" }),
                  html:
                    intl.formatMessage({ id: "userDejaConnecte" }) +
                    responseCheckAdmin.ip +
                    "<br>" +
                    `<b>${intl.formatMessage({ id: "userDejaConnecte_data_connection" })}</b> ${dateTransformed}<br>` +
                    `<b>${intl.formatMessage({ id: "horaconnection" })}</b> ${responseCheckAdmin.hotaconnection}<br>` +
                    locationDetails
                    , 
                  icon: "warning",
                  showCancelButton: true, // Enables the Cancel button
                  confirmButtonText: intl.formatMessage({ id: "deconnect_other" }), // Text for "Disconnect" button
                  cancelButtonText: intl.formatMessage({ id: "sair" }), // Text for "Close" button
                  didOpen: () => {
                    if (location) {
                      // Initialize the map
                      const map = L.map("map", {
                        center: [location.latitude, location.longitude],
                        zoom: 12,
                      });
              
                      // Add OpenStreetMap tiles
                      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                        maxZoom: 19,
                        attribution: "© OpenStreetMap contributors",
                      }).addTo(map);
              
                      // Add a marker at the user's location
                      const marker = L.marker([location.latitude, location.longitude])
                        .addTo(map)
                        .bindPopup(`Location: ${location.city}, ${location.country}`)
                        .openPopup();
              
                      // Add click-to-zoom functionality
                      marker.on("click", () => {
                        map.setView([location.latitude, location.longitude], 18, { animate: true });
                      });
              
                      // Fix map cut-off
                      setTimeout(() => {
                        map.invalidateSize();
                      }, 300); // Short delay for Swal rendering
                    }
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Action for the "Disconnect" button
                   //  console.log("User opted to disconnect from another computer.");
              
                    // Add your disconnect logic here, such as making an API call to handle the disconnection
                    disconnectUser(responseCheckAdmin.userID, ip); // Call a function to handle the disconnection
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Action for the "Close" button
                  //   console.log("Modal closed without any action.");
                  }
                });
              
                // Add the following CSS for proper styling of the modal and map
                const styles = `
                  #swal2-html-container {
                    text-align: left;
                    margin-top: 10px;
                  }
                  #map {
                    width: 100% !important;
                    height: 300px !important;
                  }
                `;
              
                // Append CSS styles dynamically to the page
                const styleSheet = document.createElement("style");
                styleSheet.type = "text/css";
                styleSheet.innerText = styles;
                document.head.appendChild(styleSheet);
              
                setIsButtonDisabled(false);
                setLoading(false);
                return;
              } */
              
              // Function to handle user disconnection logic

              //  return;
             

              if (response.data && response.data.user.token) 
              {

                const token = response.data.user.token;
                localStorage.setItem("authToken", token);
             //   Cookies.set("authToken", token, { expires: 1, secure: true, sameSite: "Strict" });

             console.log("777777777777777token#### ", token)

                let imageUrl = fallbackImage; // Default fallback
                imageUrl = `${getBaseURL()}/users/images?tipoDisplay=${response.data.user.photofilename  || "semfoto.png"}&typeUtilisateur=${1}`;
              

             //    console.log("imageUrl:", imageUrl);
                 await storeImageAsBase64(imageUrl);

                /*  const fexctDataNotificationNew = async () => {
                  try { */
                    setLoadingNotification({ loading: true, component: "Fetching Data..." });
                
                    const fetchGeneralData = () => {
                      console.log("fetchGeneralData() started, running in the background...");
                      console.time("fetchGeneralData Execution Time");
                    
                      setImmediate(() => {
                      //   console.log("Dispatches are now executing in the background...");
                    
                        // **Essential API Calls (Immediate)**
                        Promise.all([
                          dispatch(getUniversity("GetUnniversityForCombobox", response.data.user.id, response.data.user.role)),
                          dispatch(getAllUserAdministracao("userGetAllForAdmini", response.data.user.universityID)),
                          dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }]))
                       
                        ])
                        .then(() => {
                         //  console.log(" Essential data loaded, proceeding with background fetch...");
                          
                          // **Defer Non-Essential API Calls (Background Execution)**
                          setTimeout(() => {
                            Promise.all([
                              dispatch(getAllUserProfesssor("userGetAllByUniversityProf", response.data.user.universityID)),
                              dispatch(getAllUserFavorite("userGetAllForAdmini", response.data.user.id)),
                              dispatch(setNotificationValue(testData.user.total_nao_lida)),
                              dispatch(getAllUniteenseignementByUniveristy("getAllUniteenseignement",response.data.user.universityID)),
                              
                            ])
                            .then(() => {
                              console.timeEnd("fetchGeneralData Execution Time");
                              console.log(" All background dispatches finished.");
                            })
                            .catch(error => console.error(" Error in background data fetch:", error));
                          }, 500); // Small delay for better UX
                        })
                        .catch(error => console.error(" Error in essential data fetch:", error));
                      });
                    };
                    
                    //  Call function only where needed
                    fetchGeneralData();

                  /*   getDadosEntradaParaIndexDB(response.data.user.universityID,
                      response.data.user.id,
                      response.data.user.role,
                      ); */

                    // for kes prmoss all, autres boir layout/hedear
                  /*   await Promise.all([
                      dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }])),
                      dispatch(getFacultyForConfigOnly("Generalanfilter", response.data.user.universityID)),
                      dispatch(getFaculty("Generalanfilter", response.data.user.id, response.data.user.role)),
                      dispatch(gteDepartement("departementsSamsFilterAdmin", response.data.user.id, response.data.user.role)),
                      dispatch(getAcademicYear("General-san-filter")),
                      dispatch(getTurma("General-san-filter")),
                      dispatch(getCoursDuration("All_coursDuration",  response.data.user.universityID))

                    ]); */

                    // setImmediate(() => {
                    //   dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }]));
                    //   dispatch(getFacultyForConfigOnly("Generalanfilter", response.data.user.universityID));
                    //   dispatch(getFaculty("Generalanfilter", response.data.user.id, response.data.user.role));
                    //   dispatch(gteDepartement("departementsSamsFilterAdmin", response.data.user.id, response.data.user.role));
                    //   dispatch(getAcademicYear("General-san-filter"));
                    //   dispatch(getTurma("General-san-filter"));
                    //   dispatch(getCoursDuration("All_coursDuration", response.data.user.universityID));
                    // });
                
                 /*  } catch (error) {
                    console.error("Error during notification data fetch:", error);
                  } finally {
                    setLoadingNotification({ loading: false, component: null });
                  } */
              //   };

             //    localStorage.setItem('storeUserdImage', base64Image);
            //     console.log('Image saved in localStorage');

             //    console.log("Token response successfully66666555:", response.data.user.token);

            //     localStorage.setItem("testKey", "testValue");
               //  console.log(localStorage.getItem("testKey"));
          //       localStorage.removeItem("testKey");

         
         /*  const fexctDataNotificationNew = async () => {
            try {
              // Track each dispatch loading separately
              setLoadingNotification({ loading: true, component: "setParamMemoire" });
              await dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }]));
          
              setLoadingNotification({ loading: true, component: "getFacultyForConfigOnly" });
              await dispatch(getFacultyForConfigOnly("Generalanfilter", response.data.user.universityID));
          
              setLoadingNotification({ loading: true, component: "getFaculty" });
              await dispatch(getFaculty("Generalanfilter", response.data.user.id, response.data.user.role));
          
              setLoadingNotification({ loading: true, component: "gteDepartement" });
              await dispatch(gteDepartement("departementsSamsFilterAdmin", response.data.user.id, response.data.user.role));
          
              setLoadingNotification({ loading: true, component: "getAcademicYear" });
              await dispatch(getAcademicYear("General-san-filter"));
          
              setLoadingNotification({ loading: true, component: "getTurma" });
              await dispatch(getTurma("General-san-filter"));
            } catch (error) {
              console.error("Error during notification data fetch:", error);
            } finally {
              setLoadingNotification({ loading: false, component: null });
            }
          }; */

          /* const fexctDataNotificationNew = async () => {
            await Promise.all([
              dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }])),
              dispatch(getFacultyForConfigOnly("Generalanfilter", response.data.user.universityID)),
              dispatch(getFaculty("Generalanfilter", response.data.user.id, response.data.user.role)),
              dispatch(gteDepartement("departementsSamsFilterAdmin", response.data.user.id, response.data.user.role)),
              dispatch(getAcademicYear("General-san-filter")),
              dispatch(getTurma("General-san-filter"))
            ]);
          }; */


       /*    Cookies.set("universityID", response.data.user.universityID, { expires: 1 });  // Store for 1 day
          Cookies.set("userID", response.data.user.id, { expires: 1 });  // Store for 1 day
          Cookies.set("userRole", response.data.user.role, { expires: 1 });  // Store for 1 day
          Cookies.set("currentyear", response.data.user.currentyear, { expires: 1 });  // Store for 1 day
          Cookies.set("currentyear", response.data.user.currentyear, { expires: 1 });  // Store for 1 day
 */
        //  console.log("###response.data.user5555555555.universityID ", response.data.user.universityID)
          
        //   fexctDataNotificationNew();

              } else {
                const fexctDataNotificationNew = async () => {
                  return Promise.all([
                 //    await dispatch(setNotificationValue(testData.user.total_nao_lida)),
                 //   await dispatch(getAllAnneeAcademique("101", null)),
                    await dispatch(setParamMemoire([{ isLoggedIn2: false }]))
                  ]);
                };     
      
               await  fexctDataNotificationNew();
              }

            }
        
            if (estudante) {

              response = await getUserEmailEtudiants(values.email, values.password);

              if (Number(response.data.attemptCount) < 4) {

                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "attention_" }),
                  html: intl.formatMessage({ id: "nombre_tentativas_aviso" }) + (4 - Number(response.data.attemptCount)) + intl.formatMessage({ id: "tentativas" }) + "</br>"
                    + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                  icon: "warning"
                  });
                }, 100);  // Small delay to ensure Swal closes first
              
                setIsButtonDisabled(false);
                setLoading(false)
                setLoadingNotification(false)

                return;
              }
          
              if (Number(response.data.attemptCount) >= 4) {

                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "attention_" }),
                    html: '<b>' + intl.formatMessage({ id: "contabloqueado_tentitavas" }) + '</b>' + "</br>"
                      + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                    icon: "warning"
                  });
                }, 100);  // Small delay to ensure Swal closes first
              
                setIsButtonDisabled(false);
                setLoading(false)
                setLoadingNotification(false)

                return;
              }
          
              if (response.data.error === "Invalid password" && response.data.attemptCount === undefined) {
            
                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "attention_" }),
                  html: intl.formatMessage({ id: "usuario_senha_incorrecrta" }),
                  icon: "error"
                  });
                }, 100);  // Small delay to ensure Swal closes first
              
                setIsButtonDisabled(false);
                setLoading(false)
                setLoadingNotification(false)

                return;
              }


             // responseStudent = await getUserEtudiantConnectd(values.email);
           
             /*  if (responseStudent && Number(responseStudent.countData) > 0) {

                const dateTransformed =  await formatDateDayMonYearAndEnglish(responseStudent.dataconnection, responseStudent.language);
   
                const ip = responseStudent.ip;
              
                const location = await getLocationByIP(ip);
              //   console.log("Location Data:", location);
              
                // Prepare location details
                const locationDetails = location
                  ? `
                      <b>${intl.formatMessage({ id: "userDejaConnecte_location" })}</b> ${location.city}, ${location.country}<br>
                      <div id="map" style="width: 100%; height: 300px; margin-top: 10px;"></div>
                    `
                  : intl.formatMessage({ id: "location_unavailable" });
              
                Swal.fire({
                  title: intl.formatMessage({ id: "attention_" }),
                  html:
                    intl.formatMessage({ id: "userDejaConnecte" }) +
                    responseStudent.ip +
                    "<br>" +
                    `<b>${intl.formatMessage({ id: "userDejaConnecte_data_connection" })}</b> ${dateTransformed}<br>` +
                    `<b>${intl.formatMessage({ id: "horaconnection" })}</b> ${responseStudent.hotaconnection}<br>` +
                    locationDetails
                    , 
                  icon: "warning",
                  showCancelButton: true, // Enables the Cancel button
                  confirmButtonText: intl.formatMessage({ id: "deconnect_other" }), // Text for "Disconnect" button
                  cancelButtonText: intl.formatMessage({ id: "sair" }), // Text for "Close" button
                  didOpen: () => {
                    if (location) {
                      // Initialize the map
                      const map = L.map("map", {
                        center: [location.latitude, location.longitude],
                        zoom: 12,
                      });
              
                      // Add OpenStreetMap tiles
                      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                        maxZoom: 19,
                        attribution: "© OpenStreetMap contributors",
                      }).addTo(map);
              
                      // Add a marker at the user's location
                      const marker = L.marker([location.latitude, location.longitude])
                        .addTo(map)
                        .bindPopup(`Location: ${location.city}, ${location.country}`)
                        .openPopup();
              
                      // Add click-to-zoom functionality
                      marker.on("click", () => {
                        map.setView([location.latitude, location.longitude], 18, { animate: true });
                      });
              
                      // Fix map cut-off
                      setTimeout(() => {
                        map.invalidateSize();
                      }, 300); // Short delay for Swal rendering
                    }
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Action for the "Disconnect" button
                   //  console.log("User opted to disconnect from another computer.");
              
                    // Add your disconnect logic here, such as making an API call to handle the disconnection
                    disconnectUserStudent(responseStudent.userID, ip); // Call a function to handle the disconnection
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Action for the "Close" button
                  //   console.log("Modal closed without any action.");
                  }
                });
              
                // Add the following CSS for proper styling of the modal and map
                const styles = `
                  #swal2-html-container {
                    text-align: left;
                    margin-top: 10px;
                  }
                  #map {
                    width: 100% !important;
                    height: 300px !important;
                  }
                `;
              
                // Append CSS styles dynamically to the page
                const styleSheet = document.createElement("style");
                styleSheet.type = "text/css";
                styleSheet.innerText = styles;
                document.head.appendChild(styleSheet);
              
                setIsButtonDisabled(false);
                setLoading(false);
                return;
              } */


              if (response.data && response.data.user.token) {
                const token = response.data.user.token;
                
              //     console.log("Token stored successfully:", token);

                // Store the token in localStorage
                localStorage.setItem("authToken", token);

                let imageUrl = fallbackImage; // Default fallback
                imageUrl = `${getBaseURLStudents()}/studentMatriculas/images?tipoDisplay=${response.data.user.photofilename  || "semfoto.png"}&typeUtilisateur=${3}`;
              
               //  console.log("imageUrl7777777777777777:", imageUrl);
                 await storeImageAsBase64(imageUrl);

                /*  const fexctDataNotificationNew = () => {
                  setImmediate(() => {
                    Promise.all([
                      dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }]))
                    ])
                    .catch(error => console.error("Error in Promise.all:", error));
                  });
                
                  // Return immediately to avoid blocking
                  return Promise.resolve();
                }; */
                                // Call the function
              //   fexctDataNotificationNew();

                const fetchStudentNotifications = () => {
                  setImmediate(() => {
                    Promise.all([
                      dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }])),
                      dispatch(setNotificationValue(testData.user.total_nao_lida)),
                      dispatch(getAllAnneeAcademiqueStudents("101", response.data.user.universityID)),
                      dispatch(getAllUserFavorite(response.data.user.id,)),

                    ]).catch(error => console.error("Error in fetchStudentNotifications:", error));
                  });
                
                  return Promise.resolve();
                };

                fetchStudentNotifications ();

              
               //  console.log("Token stored successfully:", token);
              } else {
                 console.error("Token not found in response");
              }

            }

      
            if (professor)
             {

              response = await getUserEmailProfessors(values.email, values.password, 4);   
   
                 if (Number(response.data.attemptCount) < 4) {

                  Swal.close();
                  setTimeout(() => {
                    Swal.fire({
                      title: intl.formatMessage({ id: "attention_" }),
                      html: intl.formatMessage({ id: "nombre_tentativas_aviso" }) + (4 - Number(response.data.attemptCount)) + intl.formatMessage({ id: "tentativas" }) + "</br>"
                        + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                      icon: "warning"
                    });
                  }, 100);  // Small delay to ensure Swal closes first
                
                  setIsButtonDisabled(false);
                  setLoading(false)
                  setLoadingNotification(false)
                  return;

                 
                 }
             
                 if (Number(response.data.attemptCount) >= 4) {

                  Swal.close();
                  setTimeout(() => {
                    Swal.fire({
                      title: intl.formatMessage({ id: "attention_" }),
                      html: '<b>' + intl.formatMessage({ id: "contabloqueado_tentitavas" }) + '</b>' + "</br>"
                        + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                      icon: "warning"
                    });
                  }, 100);  // Small delay to ensure Swal closes first
                
                  setIsButtonDisabled(false);
                  setLoading(false)
                  setLoadingNotification(false)
                   return;
                 }
             
                 if (response.data.error === "Invalid password" && response.data.attemptCount === undefined) {
               
                  Swal.close();
                  setTimeout(() => {
                    Swal.fire({
                      title: intl.formatMessage({ id: "attention_" }),
                      html: intl.formatMessage({ id: "usuario_senha_incorrecrta" }),
                      icon: "error"
                    });
                  }, 100);  // Small delay to ensure Swal closes first
                
                  setIsButtonDisabled(false);
                  setLoading(false)
                  setLoadingNotification(false)

                   return;
                 }


          //     responseProf = await getUserProfesseurConnectd(values.email);

             /*  if (Number(responseProf.countData) > 0) {

          //       console.log("response##### ", response);

            //     console.log("Language passed to formatDate:", response.language);


                const dateTransformed =  await formatDateDayMonYearAndEnglish(responseProf.dataconnection, responseProf.language);
   
                // console.log("dateTransforme###########d##### ", dateTransformed);

                const ip = responseProf.ip;
              //   console.error("Fetching location for IP:", ip);
              
                const location = await getLocationByIP(ip);
              //   console.log("Location Data:", location);
              
                // Prepare location details
                const locationDetails = location
                  ? `
                      <b>${intl.formatMessage({ id: "userDejaConnecte_location" })}</b> ${location.city}, ${location.country}<br>
                      <div id="map" style="width: 100%; height: 300px; margin-top: 10px;"></div>
                    `
                  : intl.formatMessage({ id: "location_unavailable" });
              
                Swal.fire({
                  title: intl.formatMessage({ id: "attention_" }),
                  html:
                    intl.formatMessage({ id: "userDejaConnecte" }) +
                    responseProf.ip +
                    "<br>" +
                    `<b>${intl.formatMessage({ id: "userDejaConnecte_data_connection" })}</b> ${dateTransformed}<br>` +
                    `<b>${intl.formatMessage({ id: "horaconnection" })}</b> ${responseProf.hotaconnection}<br>` +
                    locationDetails
                    , 
                  icon: "warning",
                  showCancelButton: true, // Enables the Cancel button
                  confirmButtonText: intl.formatMessage({ id: "deconnect_other" }), // Text for "Disconnect" button
                  cancelButtonText: intl.formatMessage({ id: "sair" }), // Text for "Close" button
                  didOpen: () => {
                    if (location) {
                      // Initialize the map
                      const map = L.map("map", {
                        center: [location.latitude, location.longitude],
                        zoom: 12,
                      });
              
                      // Add OpenStreetMap tiles
                      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                        maxZoom: 19,
                        attribution: "© OpenStreetMap contributors",
                      }).addTo(map);
              
                      // Add a marker at the user's location
                      const marker = L.marker([location.latitude, location.longitude])
                        .addTo(map)
                        .bindPopup(`Location: ${location.city}, ${location.country}`)
                        .openPopup();
              
                      // Add click-to-zoom functionality
                      marker.on("click", () => {
                        map.setView([location.latitude, location.longitude], 18, { animate: true });
                      });
              
                      // Fix map cut-off
                      setTimeout(() => {
                        map.invalidateSize();
                      }, 300); // Short delay for Swal rendering
                    }
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Action for the "Disconnect" button
                   //  console.log("User opted to disconnect from another computer.");
              
                    // Add your disconnect logic here, such as making an API call to handle the disconnection
                    disconnectUser(responseProf.userID, ip); // Call a function to handle the disconnection
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Action for the "Close" button
                  //   console.log("Modal closed without any action.");
                  }
                });
              
                // Add the following CSS for proper styling of the modal and map
                const styles = `
                  #swal2-html-container {
                    text-align: left;
                    margin-top: 10px;
                  }
                  #map {
                    width: 100% !important;
                    height: 300px !important;
                  }
                `;
              
                // Append CSS styles dynamically to the page
                const styleSheet = document.createElement("style");
                styleSheet.type = "text/css";
                styleSheet.innerText = styles;
                document.head.appendChild(styleSheet);
              
                setIsButtonDisabled(false);
                setLoading(false);
                return;
              } */

            

              if (response.data && response.data.user.token) 
              {
                const token = response.data.user.token;
                localStorage.setItem("authToken", token);

                let imageUrl = fallbackImage; // Default fallback
                imageUrl = `${getBaseURL()}/professeur/images?tipoDisplay=${response.data.user.photofilename  || "semfoto.png"}&typeUtilisateur=${2}`;
              
                
              //    console.log("imageUrl7777777777777777:", imageUrl);
                 await storeImageAsBase64(imageUrl);


             //    console.log("Token response successfully66666555:", response.data.user.token);

            //     localStorage.setItem("testKey", "testValue");
               //  console.log(localStorage.getItem("testKey"));
          //       localStorage.removeItem("testKey");

          const fexctDataNotificationNew = () => {
            setImmediate(() => {
              Promise.all([
                dispatch(setParamMemoire([{ ...response.data.user, isLoggedIn2: true }]))
              ])
              .catch(error => console.error("Error in Promise.all:", error));
            });
          
            // Return immediately to avoid blocking
            return Promise.resolve();
          };
          
          // Call the function
          fexctDataNotificationNew();
          
          } else {
            const fexctDataNotificationNew = () => {
              setImmediate(() => {
                Promise.all([
                  dispatch(setParamMemoire([{ isLoggedIn2: false }]))
                ])
                .catch(error => console.error("Error in Promise.all:", error));
              });
          
              // Return immediately to avoid blocking
              return Promise.resolve();
            };
          
            // Call the function
            fexctDataNotificationNew();
          }


            }   // fim profeseur

            
           /*  if (Number(response.data.attemptCount) < 4) {
              Swal.fire({
                title: intl.formatMessage({ id: "attention_" }),
                html: intl.formatMessage({ id: "nombre_tentativas_aviso" }) + (4 - Number(response.data.attemptCount)) + intl.formatMessage({ id: "tentativas" }) + "</br>"
                  + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                icon: "warning"
              });
              setIsButtonDisabled(false);
              stopTimer();

              return;
            }

        
            if (Number(response.data.attemptCount) >= 4) {
              Swal.fire({
                title: intl.formatMessage({ id: "attention_" }),
                html: '<b>' + intl.formatMessage({ id: "contabloqueado_tentitavas" }) + '</b>' + "</br>"
                  + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                icon: "warning"
              });
              setIsButtonDisabled(false);
              stopTimer();

              return;
            }
        
            if (response.data.error === "Invalid password" && response.data.attemptCount === undefined) {
              Swal.fire({
                title: intl.formatMessage({ id: "attention_" }),
                html: intl.formatMessage({ id: "usuario_senha_incorrecrta" }),
                icon: "error"
              });
              setIsButtonDisabled(false);
              stopTimer();

              return;
            } */

           // Extract attemptCount from the response or default it to undefined
      /*   const attemptCount = response?.data?.attemptCount ?? undefined;

          // Check if error is "Invalid password" and handle cases for attemptCount
          if (response?.data?.error === "Invalid password") {

            if (attemptCount === undefined) {
              // Handle the case where attemptCount is missing or undefined
              swal(
                intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                intl.formatMessage({ id: "usuario_senha_incorrecrta" }),
                "error"
              );
              setIsButtonDisabled(false);
              stopTimer();
              return;
            } 
          } */

            if (Number(response.data?.user?.status) !== undefined) {

            if (Number(response.data?.user?.status) > 2) {
              if (response?.data?.error !== undefined) {

                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                    html: '<b>' + intl.formatMessage({ id: "compte_user_suspended" }) + '</b>' + "</br>"
                    + intl.formatMessage({ id: "university_desactive_error2" }),
                    icon: "warning"
                  });
                }, 100);  // Small delay to ensure Swal closes first
  
                setIsButtonDisabled(false);
                stopTimer();
                return;
              } 
            }
            }

            const universitySattus = response?.data?.user?.universitySattus;

            if (Number(universitySattus) > 1) {

              Swal.close();
              setTimeout(() => {
                Swal.fire({
                  title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                  html: '<b>' + intl.formatMessage({ id: "university_desactive_error" }) + '</b>' + "</br>"
                  + '<b>' + intl.formatMessage({ id: "university_desactive_error2" }) + '</b>' + "</br>",
                  icon: "warning"
                });
              }, 100);  // Small delay to ensure Swal closes first

              setIsButtonDisabled(false);
              stopTimer();
              return;
            }


         /*    if (Number(attemptCount) < 4) {
              Swal.fire({
                title: intl.formatMessage({ id: "attention_" }),
                html: intl.formatMessage({ id: "nombre_tentativas_aviso" }) + (4 - Number(attemptCount)) + intl.formatMessage({ id: "tentativas" }) + "</br>"
                  + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                icon: "warning"
              });
              setIsButtonDisabled(false);
              stopTimer();
              return;
            }
        
            if (Number(attemptCount) >= 4) {
              Swal.fire({
                title: intl.formatMessage({ id: "attention_" }),
                html: '<b>' + intl.formatMessage({ id: "contabloqueado_tentitavas" }) + '</b>' + "</br>"
                  + '<b>' + intl.formatMessage({ id: "senha_incorrecta" }) + '</b>' + "</br>",
                icon: "warning"
              });
              setIsButtonDisabled(false);
              stopTimer();

              return;
            }
        
            if (response.data.error === "Invalid password" && attemptCount === undefined) {
              Swal.fire({
                title: intl.formatMessage({ id: "attention_" }),
                html: intl.formatMessage({ id: "usuario_senha_incorrecrta" }),
                icon: "error"
              });
              setIsButtonDisabled(false);
              stopTimer();

              return;
            } */
        

            if (response?.data?.user?.status == 2) {                               
              // Close existing Swal first
              Swal.close();
              setTimeout(() => {
                Swal.fire({
                  title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                  html: `<b>${intl.formatMessage({ id: "contabloqueado_tentitavas" })}</b><br>${intl.formatMessage({ id: "consulter_administrateur" })}`,
                  icon: "error"
                });
              }, 100);  // Small delay to ensure Swal closes first
            
              setIsButtonDisabled(false);
              setLoading(false)
              setLoadingNotification(false)
              return;
            }
            
        
            if (response.status === 401) {

              Swal.close();
              setTimeout(() => {
                Swal.fire({
                  title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                  html: '<b>' + intl.formatMessage({ id: "usuario_senha_incorrecrta" }) + '</b>' + "</br>",
                  icon: "warning"
                });
              }, 100);  // Small delay to ensure Swal closes first

              setLoading(false)
              setIsButtonDisabled(false);
              setLoadingNotification(false)
              return;

            } else if (response) {
              testData = response.data;
        
              if (Number(testData.user.bloqueioEstudante) > 0) {

                Swal.close();
                setTimeout(() => {
                  Swal.fire({
                    title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                    html: intl.formatMessage({ id: "bloquear_estudante_login" })
                    + '<br><b>' + intl.formatMessage({ id: "bloquear_estudante_login2" }) + '</b>',
                    icon: "error"
                  });
                }, 100);  // Small delay to ensure Swal closes first
              
                setIsButtonDisabled(false);
                setLoading(false)
                setLoadingNotification(false)

                return;
              }
        
              if (!response.data.error) {
                setErrorDisplay(false);

                if (Number(testData.user.checkPrivileges) === 0  &&  Number(testData.user.role) <5) {
                
                  Swal.close();
                  setTimeout(() => {
                    Swal.fire({
                      title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                      html: intl.formatMessage({ id: "privlige_login_refused" }),
                      icon: "error"
                    });
                  }, 100);  // Small delay to ensure Swal closes first
                
                  setIsButtonDisabled(false);
                  setLoading(false)
                  setLoadingNotification(false)

                  return;
                }

                let userType = Number(testData.user.typeUtilisateur);
                const universityID = testData.user.universityID;
                const userID = testData.user.id;
                
                if(Number(testData.user.role) === 5)
                {
                  userType = 5 ;
                }
               
                  // updte user enligne = 1
              
                  if(Number(userType  < 3)) 
                  {
                    const disconnect = {
                      enligne : 1,
                      disconectBeforeConnect : 0,
                      tipo : "updateEnLigneNew",
                      userID
                    }
                    
                    await  UserService.update(userID, disconnect).
                      then((response) => {
      
                      })
                }


                if(Number(userType  === 3)) 
                {
                  const disconnect = {
                    enligne : 1,
                    disconectBeforeConnect : 0,
                    tipo : "userUpdateEnLigneStudentLogin",
                    userID
                  }

                  await  UserService.updateStudent(userID, disconnect).
                    then((response) => {
    
                    })

              }

                  // fin update user en ligne  = 1

                  if(Number(userType  < 3))  {

                    /* const fexctDataNotification = () => {
                      setImmediate(() => {
                        Promise.all([
                          dispatch(setNotificationValue(testData.user.total_nao_lida)),
                          dispatch(getAllAnneeAcademique("101", null))
                        ])
                        .catch(error => console.error("Error in Promise.all:", error));
                      });
                    
                      // Return immediately to avoid blocking
                      return Promise.resolve();
                    };
                     */
                    // Call the function without `await` to keep it non-blocking
                  //  fexctDataNotification();
  
              }
        

              if(Number(userType  >= 3))  {
                
                /*   const fexctDataNotificationStudents = () => {
                    setImmediate(() => {
                      Promise.all([
                        dispatch(setNotificationValue(testData.user.total_nao_lida)),
                        dispatch(getAllAnneeAcademiqueStudents("101", null))
                      ])
                      .catch(error => console.error("Error in Promise.all:", error));
                    });
                  
                    // Return immediately to avoid blocking
                    return Promise.resolve();
                  };
                  
                  // Call the function without `await` to ensure non-blocking execution
                  fexctDataNotificationStudents();
 */

  
              }

                setuserId(testData.user.id);

                if(Number(userType  < 3)) 
                {

                /*   const getUserFavorite = () => {
                    setImmediate(() => {
                      Promise.all([
                        dispatch(getAllUserFavorite(userID))
                      ])
                      .catch(error => console.error("Error in Promise.all:", error));
                    });
                  
                    // Return immediately to avoid blocking
                    return Promise.resolve();
                  };
                  
                  // Call the function without `await` to ensure it runs in the background
                  getUserFavorite(); */

              }

              if(Number(userType  >= 3)) 
              {
               /*  const getUserFavorite = () => {
                  setImmediate(() => {
                    Promise.all([
                      dispatch(getAllUserFavoriteStudebts(userID))
                    ])
                    .catch(error => console.error("Error in Promise.all:", error));
                  });
                
                  // Return immediately to avoid blocking
                  return Promise.resolve();
                };
                
                // Call the function without `await` to ensure it runs in the background
                getUserFavorite(); */
            }

                if (Number(testData.user.alterarSenha) === 2
                ) {
                  if (userType >= 3  && userType  < 5) {
                    stopTimer();

                    navigate.push(ALTERAR_SENHA_PATHSTUDENTS);
                    return
                  } else { 
                    stopTimer();
                    setconnectionToFuturiss(false);
                    navigate.push(ALTERAR_SENHA_PATH);
                    return
                  }
                }

                if (userType === 1) {

                   // updte user enligne = 1
                const disconnect2 = {
                  enligne : 1,
                  disconectBeforeConnect : 0,
                  tipo : "updateEnLigneNew",
                  userID
                }

               await  UserService.update(userID, disconnect2).
                then((response) => {

                })
                // fin update user en ligne  = 1

                await   logUtilisateurs(userID, "Login", "Login no sistema", testData.user.firstname, testData.user.lastname);
                 //  await fetchAdminData();
                 stopTimer();
                 setIsButtonDisabled(false);
                setLoading(false)
                setLoadingNotification(false)
                
                 navigate.push("/dashboard/index");

                 
                } else
                 if (Number(userType) === 2) {

                  const disconnect2 = {
                    enligne : 1,
                    disconectBeforeConnect : 0,
                    tipo : "updateEnLigneNew",
                    userID
                  }
                 await  UserService.update(userID, disconnect2).
                  then((response) => {
  
                  })
                  // fin update user en ligne  = 1
  
                  await   logUtilisateurs(userID, "Login", "Login no sistema", testData.user.firstname, testData.user.lastname);
                 //     await fetchAdminData();
                 //   await fetchStudentData();
                 stopTimer();

                  navigate.push("/dashboard/index");

                } else if (userType === 3) {
                  const disconnect2 = {
                  enligne : 1,
                  disconectBeforeConnect : 0,
                  tipo : "updateEnLigneNew",
                  userID
                }
                
               await  UserService.updateStudents(userID, disconnect2).
                then((response) => {

                })

                // fin update user en ligne  = 1

              //  await   logUtilisateurs(userID, "Login", "Login no sistema", testData.user.firstname, testData.user.lastname);
               //    await fetchAdminData();
               //   await fetchStudentData();

               stopTimer();

                 navigate.push("/dashboard/index");

                //   await fetchStudentData(); // chnged location
                } else if (userType === 5) {
                  const disconnect2 = {
                    enligne : 1,
                    disconectBeforeConnect : 0,
                    tipo : "updateEnLigneNew",
                    userID
                  }
                 await  UserService.update(userID, disconnect2).
                  then((response) => {
  
                  })
                  // fin update user en ligne  = 1
  
                 //   await   logUtilisateurs(userID, "Login", "Login no sistema", testData.user.firstname, testData.user.lastname);
                   //  await fetchAdminData();
                // //    await fetchStudentData();
                   await   logUtilisateurs(userID, "Login", "Login no sistema", testData.user.firstname, testData.user.lastname);
  
                   stopTimer();

                   navigate.push("/dashboard/indexGardeControleAccess");
                   
                  }
        
               
              } else {

                setErrorDisplay(true);
                setIsButtonDisabled(false);
                stopTimer();

                setMessage(response.data.message);
              //   console.log("response.data.message###### ", response.data.message)
                return;

              }

            } else {
              stopTimer();

              Swal.close();
              setTimeout(() => {
                Swal.fire({
                  title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
                  html: intl.formatMessage({ id: "internet_connexion_perdu_message" }),
                  icon: "error"
                });
              }, 100);  // Small delay to ensure Swal closes first
            
              setIsButtonDisabled(false);
              setLoading(false)
              setLoadingNotification(false)
              return;
            }
          } catch (err) {
            stopTimer();
            setMessage(intl.formatMessage({ id: "usuario_senha_incorrecrta" }));
            setIsButtonDisabled(false);
          }
        }} 
      >
        {({
          errors,
          handleBlur,
         handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate 
          onSubmit={(e) => {
            e.preventDefault(); // Prevent form refresh manually
            handleSubmit(e);
          }}
           {...others}>

          <Grid container spacing={1} alignItems="center">
            <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                     checked={administrativo}
                      onChange={handleChangeAdministrativo}
                      name="administrativo"
                      id="1"
                      color="primary"
                    />
                  }
                  label={intl.formatMessage({ id: "administratif_" })}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={professor}
                      onChange={handleChangeProfessor}
                      name="professor"
                      id="2"
                      color="primary"
                    />
                  }
                  label={intl.formatMessage({ id: "professeur_" })}
                />
                 <FormControlLabel
                  control={
                    <Checkbox
                     checked={estudante}
                     onChange={handleChangeEtudiant}
                      name="estudante"
                      id="3"
                      color="primary"
                    />
                  }
                  label={intl.formatMessage({ id: "etudiant_" })}
                />
              </FormGroup>
              
              
            </Grid>

            <FormControl
              fullWidth
              error={Boolean(touched.email && errors.email)}
              sx={{ ...theme.typography.customInput }}
            >
              <InputLabel htmlFor="outlined-adornment-email-login">
                {intl.formatMessage({ id: "login_email_username" })}
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-email-login"
                type="email"
                value={values.email}
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                // autoComplete="new-password"

                label={intl.formatMessage({ id: "login_email_username" })}
                inputProps={{}}
              />
              {touched.email && errors.email && (
                <FormHelperText
                  error
                  id="standard-weight-helper-text-email-login"
                >
                  {errors.email}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              error={Boolean(touched.password && errors.password)}
              sx={{ ...theme.typography.customInput }}
            >
              <InputLabel htmlFor="outlined-adornment-password-login">
                {intl.formatMessage({ id: "senha" })}
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password-login"
                type={
                  showPassword
                    ? "password"
                    : intl.formatMessage({ id: "senha" })
                }
                value={values.password}
                name="password"
                autoComplete="new-password"
                onBlur={handleBlur}
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      size="large"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                label={intl.formatMessage({ id: "senha" })}
                inputProps={{}}
              />
              {touched.password && errors.password && (
                <FormHelperText
                  error
                  id="standard-weight-helper-text-password-login"
                >
                  {errors.password}
                </FormHelperText>
              )}
            </FormControl>
          
            {errorDisplay ? (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>{message}</FormHelperText>
              </Box>
            ) : null}

      <Box sx={{ mt: 2 }}>
        <AnimateButton>

     
      <Button
      disableElevation
      disabled={isButtonDisabled } // Disable if notification data is loading
      fullWidth
      size="large"
      type="submit"
      variant="contained"
      color="secondary"
    >
      {loadingNotification.loading && (
  <Typography variant="body2">
    Loading {loadingNotification.component}...
  </Typography>
  
)}


{/* 
{loadingNotification ?
<DispatchLoadingComponent loadingDispatch={loadingNotification.component} />
 :null
} */}
{loadingNotification ? <CircularProgress size={24} color="inherit" /> : intl.formatMessage({ id: "login2" })}
 
    </Button>

        </AnimateButton>
        <Typography align="left" variant="body2"></Typography>
      </Box>
            
      <Grid item xs={12}>
      <Typography align="left" variant="body2" style={{ marginTop: '10px' }}>
        <a
          href="#"
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
          onClick={(event) => {
            event.preventDefault(); // Optional: Prevent default anchor behavior
            handleClick(event); // Trigger your function
          }}
        >
          <Home />
          {intl.formatMessage({ id: 'page_principale' })}
        </a>
      </Typography>
    </Grid>


          </form>
        )}
      </Formik>
    </>
  );
};

FirebaseLogin.propTypes = {
  loginProp: PropTypes.number,
};

export default FirebaseLogin;

